export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  render: function render(h, context) {
    var _context$props = context.props,
      icon = _context$props.icon,
      title = _context$props.title;
    var vnodes = [];
    if (icon) {
      vnodes.push(h("svg-icon", {
        "attrs": {
          "icon-class": icon
        }
      }));
    }
    if (title) {
      vnodes.push(h("span", {
        "slot": 'title'
      }, [title]));
      // var regex=/^[a-zA-Z0-9_\u4e00-\u9fa5]+分析$/.test(title)
      //  if(regex){
      //  vnodes.push(<span style='font-size:12px;' slot='title'>{(title)}</span>)
      //  }else{
      //     vnodes.push(<span slot='title'>{(title)}</span>)
      //  }
    }
    return vnodes;
  }
};